import { Component, HostListener, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-bar',
  templateUrl: './bar.component.html',
  styleUrls: ['./bar.component.css']
})
export class BarComponent implements OnInit, OnChanges {
  chartOption: any;
  @Input() barChartData: any;
  @HostListener('window:resize', ['$event'])
  onResize() {
    setTimeout(() => {
      this._plotBar();
      // this.chartOption?.resize();
    }, 1);
  }
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.barChartData) {
      this._plotBar();
    }
  }

  private _plotBar() {
    this.chartOption = {
      tooltip: {
        trigger: 'axis'
      },
      grid: {
        top: '5%'
      },
      xAxis: {
        type: 'category',
        data: this.barChartData?.barXaxisData,
        name: this.barChartData?.xAxisLabel ? this.barChartData?.xAxisLabel : '',
        nameLocation: this.barChartData?.yNameLocation ? this.barChartData?.yNameLocation : 'middle',
        nameTextStyle: {
          fontFamily: 'Inter',
          fontSize: 12,
          fontWeight: 400,
          color: '#9291A5'
        },
        axisTick: {
          show: this.barChartData?.xAxisTick ? this.barChartData?.xAxisTick : false
        },
        splitLine: {
          show: true, // Show grid lines
        },
        nameGap: 40
      },
      yAxis: {
        type: 'value',
        name: this.barChartData?.yAxisLabel ? this.barChartData?.yAxisLabel : '',
        nameLocation: this.barChartData?.yNameLocation ? this.barChartData?.yNameLocation : 'middle',
        nameTextStyle: {
          fontFamily: 'Inter',
          fontSize: 12,
          fontWeight: 400,
          color: '#9291A5'
        },
        axisTick: {
          show: this.barChartData?.yAxisTick ? this.barChartData?.yAxisTick : false
        },
        axisLabel: {
          show: !this.barChartData?.yaxisLabelShow ? false : true
        },
        splitLine: {
          show: false, // Show grid lines
        },
      },
      color: this.barChartData?.color ? this.barChartData?.color : [],
      series: [
        {
          data: this.barChartData?.barData,
          type: 'bar',
          barWidth: this.barChartData?.barWidth ? this.barChartData?.barWidth : null
        }
      ]
    };
  }

}
